import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';
import _intersection from 'lodash/intersection';

export default class VisitorProfileAbility extends Ability {
  @service declare authz: AuthzService;

  /**
   * this.abilities.can('read visitor-profiles')
   */
  get canRead(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_VISITOR_PROFILE_READ);
  }
}
